export const exportToExcel = (data, filename, columns) => {
  if (!data || !data.length) return;

  // Create header row
  const headers = columns.map(col => col.header);
  
  // Create data rows
  const rows = data.map(item => {
    return columns.map(col => {
      let value = '';
      if (typeof col.key === 'function') {
        value = col.key(item);
      } else {
        value = item[col.key];
      }
      
      // Basic escaping for CSV (wrap in quotes if contains comma or quote)
      if (value === null || value === undefined) {
        return '';
      }
      
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    });
  });

  const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
